import React from "react";
import { Helmet } from "react-helmet-async";
import PageWrapper from "../../Components/Layout/PageWrapper/PageWrapper";
import NavigationBar from "../../Components/HighLevelComponents/NavigationBar/NavigationBar";

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Yippity</title>
        <meta
          name="description"
          content="Yippity's Privacy Policy - Learn how we collect, use, and protect your data."
        />
      </Helmet>

      <PageWrapper>
        <NavigationBar />
        <div className="container mx-auto px-4 py-16 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Privacy Policy
          </h1>
          <div className="prose prose-lg">
            <p className="text-gray-600 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-600 mb-4">
              Welcome to Yippity. We respect your privacy and are committed to
              protecting your personal data. This privacy policy will inform you
              about how we look after your personal data when you visit our
              website and tell you about your privacy rights and how the law
              protects you.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              2. Information We Collect
            </h2>
            <p className="text-gray-600 mb-4">
              We may collect, use, store and transfer different kinds of
              personal data about you, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Identity Data (name, username)</li>
              <li>Contact Data (email address)</li>
              <li>Technical Data (IP address, browser type)</li>
              <li>Usage Data (how you use our website)</li>
              <li>Marketing and Communications Data</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              3. How We Use Your Data
            </h2>
            <p className="text-gray-600 mb-4">
              We will only use your personal data for the purposes for which we
              collected it, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>To provide and maintain our service</li>
              <li>To notify you about changes to our service</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information</li>
              <li>To monitor the usage of our service</li>
              <li>To detect, prevent and address technical issues</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              4. Data Security
            </h2>
            <p className="text-gray-600 mb-4">
              We have put in place appropriate security measures to prevent your
              personal data from being accidentally lost, used, or accessed in
              an unauthorized way. We limit access to your personal data to
              those employees, agents, contractors, and other third parties who
              have a business need to know.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              5. Your Legal Rights
            </h2>
            <p className="text-gray-600 mb-4">
              Under certain circumstances, you have rights under data protection
              laws in relation to your personal data, including the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Request access to your personal data</li>
              <li>Request correction of your personal data</li>
              <li>Request erasure of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Request restriction of processing your personal data</li>
              <li>Request transfer of your personal data</li>
              <li>Right to withdraw consent</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              6. Contact Us
            </h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about this Privacy Policy, please
              contact us at:
            </p>
            <p className="text-gray-600">Email: support@yippity.io</p>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default PrivacyPolicy;
